import cls from 'classnames';
import React from 'react';
import { Avatar, type AvatarProps } from 'antd';
import { useVipLevel } from '@/hooks';
import { getOssImageUrl } from '@/utils';

import styles from './index.module.scss';

export const UserAvatar: React.FC<AvatarProps> = ({
  className,
  children,
  src,
  ...extraProps
}) => {
  const { vipLevel } = useVipLevel();

  return (
    <div className={cls(styles.wrap, className)}>
      <Avatar
        {...extraProps}
        src={
          typeof src === 'string'
            ? getOssImageUrl(src, { mode: 'fill', width: 256, height: 256 })
            : src
        }
      >
        {children}
      </Avatar>
      {vipLevel.vip_icon && (
        <img
          className={styles.icon}
          src={getOssImageUrl(vipLevel.vip_icon, {
            mode: 'lfit',
            width: 256,
            height: 256,
          })}
        />
      )}
    </div>
  );
};
